import { Button } from '@mantine/core';
import { tKeys } from 'locales';
import { useTranslation } from 'locales/logic';

export const CancelButton = (
  props: React.ComponentProps<typeof Button> & React.HTMLAttributes<HTMLButtonElement>,
) => {
  const { t } = useTranslation();

  return (
    <Button color="orange" variant="light" {...props}>
      {t(tKeys.CANCEL)}
    </Button>
  );
};
